exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_confettiElement_kqw_vcNJkf4TaickcJkDM {\n  position: fixed;\n  width: 100px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  pointer-events: auto;\n  z-index: 4000001;\n}", ""]);

// Exports
exports.locals = {
	"IA_confettiElement": "IA_confettiElement_kqw_vcNJkf4TaickcJkDM"
};